<template>
    <div
        :data-component-name="$options.name"
    >
        <div v-if="$apollo.loading" class="-loading">
            <q-spinner
                color="primary"
                size="1em"
            />
            Chargement en cours...
        </div>
        <div v-else class="c-project-card">
            <div class="-controls text-right">
                <!-- <button
                    v-if="project && myProfile && (myProfile.role=='ADMINISTRATOR' || myProfile.role=='MANAGER')"
                    class="o-button -blue -outline -md"
                    @click.prevent="$eventBus.$emit('jump-to-project', {projectID: project.id, currentDate: project.start_date})"
                >
                    Ouvrir le projet
                    <q-icon name="launch" class="o-ico -right" />
                </button> -->
                <button class="o-button -blue -outline -md q-ml-md" onclick="window.print();">
                    Imprimer
                    <q-icon name="print" class="o-ico -right" />
                </button>
                <button class="o-button -blue -md q-ml-md"
                    @click.stop="$emit('close-dialog')"
                >
                    Fermer
                    <q-icon name="close" class="o-ico -right" />
                </button>
            </div>
            <div class="col -project">
                <h2 class="row  q-mx-md">
                    Affectations du {{ date2str(summary.date).long}}
                </h2>
                <!-- <div class="q-mt-xl -summary-no-frame">
                    <h3 class="-title">Sommaire</h3>
                </div> -->
                <div class="row q-my-lg -summary-frame q-mx-md">
                    <div class="col-6 ">

                        <div class="row">
                            <label class="-report-label col-3">
                                Publiées :
                            </label>
                            <span class="col-8">
                                {{ summary.count }}
                            </span>
                        </div>
                        <div class="row">
                            <label class="-report-label col-3">
                                Planifiées :
                            </label>
                            <span class="col-8">
                                {{ summary.draftCount }}
                            </span>
                        </div>
                        <div class="row">
                            <label class="-report-label col-3">
                                Non assignées :
                            </label>
                            <span class="col-8">
                                {{ summary.unassigned }}
                            </span>
                        </div>
                    </div>
                    <div class="col-6 ">

                        <div class="row">
                            <label class="-report-label col-3">
                                Acceptées :
                            </label>
                            <span class="col-8">
                                {{ summary.accepted }}
                            </span>
                        </div>

                        <div class="row">
                            <label class="-report-label col-3">
                                Refusées :
                            </label>
                            <span class="col-8">
                                {{ summary.denied }}
                            </span>
                        </div>

                        <div class="row">
                            <label class="-report-label col-3">
                                Peut-être :
                            </label>
                            <span class="col-8">
                                {{ summary.maybe }}
                            </span>
                        </div>

                        <div class="row">
                            <label class="-report-label col-3">
                                En attente :
                            </label>
                            <span class="col-8">
                                {{ summary.pending }}
                            </span>
                        </div>

                    </div>

                </div>
                <div v-if="!loadingA && !loadingD" class="-summary-no-frame">
                    <!-- <h3 class="q-mb-sm">Filtres</h3> -->

                    <h3 class="q-mb-md q-pt-md">
                        <div class="q-gutter-sm">
                            <label>
                                <input v-model="detailsType" type="radio" value="professions" class="q-mr-xs">
                                Détails par métiers
                            </label>
                            <label class="q-ml-lg">
                                <input v-model="detailsType" type="radio" value="assignments" class="q-mr-xs">
                                Détails par affectations
                            </label>
                        </div>
                    </h3>


                    <div class="row -filters items-center q-mb-md">

                        <div class="col-3">
                            <q-select
                                v-if="typeChoices"
                                v-model="filters.type"
                                :options="typeChoices"
                                label="Affectations"
                                class="q-mr-sm"
                                map-options
                                emit-value
                                :filled="false"
                                dense
                                outlined
                            />
                        </div>

                        <div class="col-3">
                            <q-select
                                v-if="projectsChoices && projectsChoices.length>1"
                                v-model="filters.projects"
                                :options="projectsOptions"
                                label="Projets"
                                class="q-mr-sm"
                                map-options
                                emit-value
                                :filled="false"
                                dense
                                outlined
                                multiple
                                clearable
                            >
                                <template v-slot:before-options v-if="projectsChoices.length > 5">
                                    <q-item>
                                        <Input v-model="searchProjects" placeholder="Rechercher / Filtrer" class="full-width c-select-filter-input"
                                            autofocus :filled="false" dense flat borderless />
                                    </q-item>
                                </template>
                                <template v-slot:no-option v-if="projectsChoices.length > 5">
                                    <q-item>
                                        <Input v-model="searchProjects" placeholder="Rechercher / Filtrer" class="full-width c-select-filter-input"
                                            autofocus :filled="false" dense flat borderless />
                                    </q-item>
                                </template>
                            </q-select>
                        </div>

                        <div class="col-3">
                            <q-select
                                v-if="professionsChoices && professionsChoices.length>1"
                                v-model="filters.professions"
                                :options="professionsOptions"
                                label="Métiers"
                                class="q-mr-sm"
                                map-options
                                emit-value
                                :filled="false"
                                dense
                                outlined
                                multiple
                                clearable
                            >
                                <template v-slot:before-options v-if="professionsChoices.length > 5">
                                    <q-item>
                                        <Input v-model="searchProfessions" placeholder="Rechercher / Filtrer" class="full-width c-select-filter-input"
                                            autofocus :filled="false" dense flat borderless />
                                    </q-item>
                                </template>
                                <template v-slot:no-option v-if="professionsChoices.length > 5">
                                    <q-item>
                                        <Input v-model="searchProfessions" placeholder="Rechercher / Filtrer" class="full-width c-select-filter-input"
                                            autofocus :filled="false" dense flat borderless />
                                    </q-item>
                                </template>
                            </q-select>
                        </div>

                        <div class="col-3">
                            <q-select
                                v-if="assignedToChoices && assignedToChoices.length>1"
                                v-model="filters.assignedTo"
                                :options="assignedToOptions"
                                label="Utilisateur"
                                class=""
                                map-options
                                emit-value
                                :filled="false"
                                dense
                                outlined
                                multiple
                                clearable
                            >
                                <template v-slot:before-options v-if="assignedToChoices.length > 5">
                                    <q-item>
                                        <Input v-model="searchAssignedTo" placeholder="Rechercher / Filtrer" class="full-width c-select-filter-input" autofocus
                                            :filled="false" dense flat borderless />
                                    </q-item>
                                </template>
                                <template v-slot:no-option v-if="assignedToChoices.length > 5">
                                    <q-item>
                                        <Input v-model="searchAssignedTo" placeholder="Rechercher / Filtrer" class="full-width c-select-filter-input" autofocus
                                            :filled="false" dense flat borderless />
                                    </q-item>
                                </template>
                            </q-select>
                        </div>

                    </div>

                    <div class="row -head text-right">
                        <div class="col-12">
                            <span>
                                {{ filteredAssignments.length }} /
                            </span>
                            <span v-if="filters.type == 'assignments'">
                                {{ assignmentsAll.assignmentsAll.length }}
                            </span>
                            <span v-else>
                                {{ draftAssignmentsAll.draftAssignmentsAll.length }}
                            </span>
                            <span>
                                affectations
                            </span>
                        </div>
                    </div>


                    <div class="q-mb-lg" v-if="detailsType=='professions'">
                        <div class="row -head">
                            <div class="col-6">
                                Métiers
                            </div>
                            <div class="col-2 text-center">
                                Code
                            </div>
                            <div class="col-2 text-center">
                                Heures
                            </div>
                            <div class="col-2 text-right">
                                Affectations
                            </div>
                        </div>
                        <div class="row -body" v-for="(profession, pri) in filteredProfessions" :key="pri">
                            <div class="col-6">
                                {{ profession.label }}
                            </div>
                            <div class="col-2 text-center">
                                {{ profession.shortname }}
                            </div>
                            <div class="col-2 text-center">
                                {{ profession.totalHours.toFixed(2) }} heures
                            </div>
                            <div class="col-2 text-right">
                                {{ profession.count }} affectation<span v-if="profession.count>1">s</span>
                            </div>
                        </div>
                        <div class="row -body text-weight-bold q-py-sm total-row" style="border-top: 1px solid black; border-color: black !important;">
                            <div class="col-6">
                                Total
                            </div>
                            <div class="col-2 text-center">
                                {{ Object.keys(filteredProfessions).length }}
                            </div>
                            <div class="col-2 text-center">
                                {{ Object.keys(filteredProfessions).reduce((acc, key) => acc + filteredProfessions[key].totalHours, 0).toFixed(2) }} heures
                            </div>
                            <div class="col-2 text-right">
                                {{ Object.keys(filteredProfessions).reduce((acc, key) => acc + filteredProfessions[key].count, 0) }}
                                affectations
                            </div>
                        </div>
                    </div>



                    <div v-if="detailsType=='assignments'">
                        <div class="row -head">
                            <div class="col-4">
                                Projets
                            </div>
                            <div class="col-2">
                                Métiers
                            </div>
                            <div class="col-4">
                                Affecté à
                            </div>
                            <div class="col-1 text-center">
                                Horaire
                            </div>
                            <div class="col-1 text-right">
                                heures
                            </div>
                        </div>
                        <div class="row -body" v-for="(assignment, air) in filteredAssignments" :key="air">
                            <div class="col-4">
                                <div>
                                    {{ assignment.project.name }}
                                </div>
                                <div>
                                    {{ assignment.shift.name }}
                                </div>
                            </div>
                            <div class="col-2">
                                {{ assignment.profession.name }}
                            </div>
                            <div class="col-4" v-if="assignment.assignedTo">
                                {{ assignment.assignedTo.name }}&nbsp;<UserProfileInfo :userProfile="assignment.assignedTo" />
                            </div>
                            <div class="col-4 text-red" v-else>
                                Non affecté
                            </div>
                            <div class="col-1 text-center">
                                <div>
                                    {{ assignment.start_time }}
                                </div>
                                <div>
                                    {{ assignment.end_time }}
                                </div>
                            </div>
                            <div class="col-1 text-right">
                                {{ assignment.duration.toFixed(2) }}&nbsp;h
                            </div>
                        </div>
                        <div class="row -body text-weight-bold q-py-sm total-row" style="border-top: 1px solid black; border-color: black !important;">
                            <div class="col-6">
                                Total
                            </div>
                            <div class="col-6 text-right">
                                {{ filteredAssignments.reduce((acc, assignment) => acc + assignment.duration, 0).toFixed(2) }}&nbsp;h
                            </div>
                        </div>
                    </div>


                </div>
            </div>

        </div>
    </div>
</template>
<script>
    // import { PROJECTCARD } from '@/graphql/project/queries'
    import {date2str} from "@/js/dateUtilities"
    // import orderBy from "lodash/orderBy";
    import { MYPROFILE } from '@/graphql/user/queries'
    import { ASSIGNMENTSALL, DRAFTASSIGNMENTSALL } from "@/graphql/assignment/queries";
    import uniqBy from 'lodash/uniqBy'
    import moment from 'moment';

    export default {
        name: 'AssignmentsCard',
        //components: { Component1, Component2 },
        props: {
        	showCard:{
        		type: Boolean,
        		default: true,
        	},
            partialsummary: {
                type: Object,
                default() { return {} }
            },
        },
        data(){
        	return {
                skipQueriesStart: true,
                project: null,
                summary: {},
                loadingA: true,
                loadingD: true,
                filters: {
                    type: 'assignments',
                    projects: [],
                    assignedTo: [],
                    professions: [],
                },
                typeChoices: [
                    {
                        label: 'Publiées',
                        value: 'assignments'
                    },
                    {
                        label: 'Planifiées',
                        value: 'draftAssignments'
                    },
                ],
                assignedToChoices: [],
                assignedToOptions: [],
                professionsChoices: [],
                professionsOptions: [],
                projectsChoices: [],
                projectsOptions: [],
                searchProjects: null,
                searchAssignedTo: null,
                searchProfessions: null,
                detailsType: 'professions',
            }
        },
        mounted(){
            if (this.showCard) this.skipQueriesStart = false

            this.summary = JSON.parse(JSON.stringify(this.partialsummary))

            let detailsType = this.$q.localStorage.getItem('detailsType');
            if (detailsType == 'professions' || detailsType == 'assignments') {
                this.detailsType = detailsType;
            }
        },
        computed: {

            filteredAssignments(){
                let assignments = [];

                if (this.filters.type == 'assignments') {
                    // assignments = this.assignmentsAll;
                    assignments = JSON.parse(JSON.stringify(this.assignmentsAll.assignmentsAll));
                } else if (this.filters.type == 'draftAssignments') {
                    // assignments = this.draftAssignmentsAll;
                    assignments = JSON.parse(JSON.stringify(this.draftAssignmentsAll.draftAssignmentsAll));
                }

                if (this.filters.projects?.length > 0) {
                    assignments = assignments.filter((assignment) => {
                        return this.filters.projects.includes(assignment.project.id)
                    })
                }

                if (this.filters.professions?.length > 0) {
                    assignments = assignments.filter((assignment) => {
                        return this.filters.professions.includes(assignment.profession.id)
                    })
                }

                if (this.filters.assignedTo?.length > 0) {
                    assignments = assignments.filter((assignment) => {
                        if (!assignment.assignedTo) return this.filters.assignedTo.includes(null)
                        return this.filters.assignedTo.includes(assignment.assignedTo.id)
                    })
                }

                assignments.forEach((assignment) => {
                    let start_date = moment(assignment.date + ' ' + assignment.start_time, 'YYYY-MM-DD HH:mm:ss');
                    let end_date = moment(assignment.date + ' ' + assignment.end_time, 'YYYY-MM-DD HH:mm:ss');

                    if (end_date < start_date) {
                        end_date = moment(moment(end_date.add(1, 'days')).toDate());
                    }
                    let hoursDiff = moment.duration(end_date - start_date).as('hours');
                    assignment.duration = hoursDiff;
                })
                return assignments;
            },

            filteredProfessions() {
                let professions = {};
                let assignments = JSON.parse(JSON.stringify(this.filteredAssignments));
                assignments.sort((a, b) => a.profession.name.localeCompare(b.label))

                assignments.forEach((assignment) => {
                    let start_date = moment(assignment.date + ' ' + assignment.start_time, 'YYYY-MM-DD HH:mm:ss');
                    let end_date = moment(assignment.date + ' ' + assignment.end_time, 'YYYY-MM-DD HH:mm:ss');

                    if (end_date < start_date) {
                        end_date = moment(moment(end_date.add(1, 'days')).toDate());
                    }
                    let hoursDiff = moment.duration(end_date - start_date).as('hours');

                    if (!professions[assignment.profession.id]) {
                        
                        professions[assignment.profession.id] = {
                            label: assignment.profession.name,
                            value: assignment.profession.id,
                            shortname: assignment.profession.shortname,
                            totalHours: hoursDiff,
                            count: 1
                        };
                    }else{
                        professions[assignment.profession.id].count++
                        professions[assignment.profession.id].totalHours = parseFloat(professions[assignment.profession.id].totalHours) + parseFloat(hoursDiff)
                    }
                })

                return professions;
            }

        },
        watch: {

            detailsType() {
                // this.$q.localStorage.getItem('detailsType');
                this.$q.localStorage.set('detailsType', this.detailsType);
            },

            loadingA() {
                if (!this.loadingA) {
                    this.setChoices()
                }
            },
            loadingB() {
                if (!this.loadingB) {
                    this.setChoices()
                }
            },

            'filters.type'() {
                this.setChoices()
            },

            showCard() {
                if(this.showCard) this.skipQueriesStart=false
            },

            searchAssignedTo(val) {
                if (!val || val === '') {
                    this.assignedToOptions = this.assignedToChoices
                    return
                }
                const needle = val.toLowerCase()
                this.assignedToOptions = this.assignedToChoices.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
            },

            searchProjects(val) {
                if (!val || val === '') {
                    this.projectsOptions = this.projectsChoices
                    return
                }
                const needle = val.toLowerCase()
                this.projectsOptions = this.projectsChoices.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
            },

            searchProfessions(val) {
                if (!val || val === '') {
                    this.professionsOptions = this.professionsChoices
                    return
                }
                const needle = val.toLowerCase()
                this.professionsOptions = this.professionsChoices.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
            },
        },
        methods: {

            setChoices() {

                let choices = [];
                let hasUnassigned = false;
                if (this.filters.type == 'assignments' && this.assignmentsAll.assignmentsAll.length) {
                    this.assignmentsAll.assignmentsAll.forEach((assignment) => {
                        if (!assignment.assignedTo) {
                            hasUnassigned = true;
                        } else {
                            choices.push({
                                label: assignment.assignedTo.name,
                                value: assignment.assignedTo.id
                            })
                        }
                    })
                } else if (this.filters.type == 'draftAssignments' && this.draftAssignmentsAll.draftAssignmentsAll.length) {
                    this.draftAssignmentsAll.draftAssignmentsAll.forEach((assignment) => {
                        if (!assignment.assignedTo) {
                            hasUnassigned = true;
                        } else {
                            choices.push({
                                label: assignment.assignedTo.name,
                                value: assignment.assignedTo.id
                            })
                        }
                    })
                }
                choices.sort((a, b) => a.label.localeCompare(b.label))
                if(hasUnassigned) choices.unshift({
                    label: 'Non affecté',
                    value: null
                })
                this.assignedToChoices = uniqBy(choices, 'value')
                this.assignedToOptions = JSON.parse(JSON.stringify(this.assignedToChoices))


                choices = [];
                if (this.filters.type == 'assignments') {
                    this.assignmentsAll.assignmentsAll.forEach((assignment) => {
                        console.log('assignment', assignment)
                        choices.push({
                            label: assignment.profession.name,
                            value: assignment.profession.id
                        })
                    })
                } else {
                    this.draftAssignmentsAll.draftAssignmentsAll.forEach((assignment) => {
                        choices.push({
                            label: assignment.profession.name,
                            value: assignment.profession.id
                        })
                    })
                }
                choices.sort((a, b) => a.label.localeCompare(b.label))
                this.professionsChoices = uniqBy(choices, 'value')
                this.professionsOptions = JSON.parse(JSON.stringify(this.professionsChoices))



                choices = [];
                if (this.filters.type == 'assignments') {
                    this.assignmentsAll.assignmentsAll.forEach((assignment) => {
                        choices.push({
                            label: assignment.project.name,
                            value: assignment.project.id
                        })
                    })
                } else {
                    this.draftAssignmentsAll.draftAssignmentsAll.forEach((assignment) => {
                        choices.push({
                            label: assignment.project.name,
                            value: assignment.project.id
                        })
                    })
                }
                choices.sort((a, b) => a.label.localeCompare(b.label))
                this.projectsChoices = uniqBy(choices, 'value')
                this.projectsOptions = JSON.parse(JSON.stringify(this.projectsChoices))


            },

            // filterUsersFn(val, update) {
            //     if (val === '') {
            //         update(() => {
            //             this.assignedToOptions = this.assignedToChoices
            //         })
            //         return
            //     }
            //     update(() => {
            //         const needle = val.toLowerCase()
            //         this.assignedToOptions = this.assignedToChoices.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
            //     })
            //     return
            // },

            // filterProfessionsFn(val, update) {
            //     if (val === '') {
            //         update(() => {
            //             this.professionsOptions = this.professionsChoices
            //         })
            //         return
            //     }
            //     update(() => {
            //         const needle = val.toLowerCase()
            //         this.professionsOptions = this.professionsChoices.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
            //     })
            //     return
            // },

            // filterProjectsFn(val, update) {
            //     if (val === '') {
            //         update(() => {
            //             this.projectsOptions = this.projectsChoices
            //         })
            //         return
            //     }
            //     update(() => {
            //         const needle = val.toLowerCase()
            //         this.projectsOptions = this.projectsChoices.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
            //     })
            //     return
            // },

            mailTO(projectShift) {

                let recipients = [];
                projectShift.projectAssignments.forEach(function (assignment) {
                    if (assignment.assignedTo && assignment.assignedTo.email) {
                        recipients.push(assignment.assignedTo.name + ' <' + assignment.assignedTo.email + '>');
                    }
                })

                recipients = recipients.join(', ');
                let description = projectShift.description && projectShift.description != '' ? ' %0D%0ADescription: ' + projectShift.description : '';
                let title = this.myProfile && this.myProfile.title && this.myProfile.title != '' ? ' %0D%0A' + this.myProfile.title : '';
                let me = this.myProfile && this.myProfile.name && this.myProfile.name != '' ? ' %0D%0A' + this.myProfile.name : '';
                let dates = [];
                if (projectShift.dates) {
                    projectShift.dates.forEach(function (date) {
                        if (date.from && date.to) {
                            dates.push('du ' + date.from + ' au ' + date.to);
                        } else {
                            dates.push(date);
                        }
                    })
                }
                dates = dates.join(', ');
                window.location.href = "mailto:" + recipients + "?subject=" + this.project.name +" - quart de travail " + projectShift.name.toLowerCase() + "&body=Bonjour, %0D%0A%0D%0AVoici les informations concernant le quart de travail : %0D%0A%0D%0AProjet : " + this.project.name + "%0D%0ANom : " + projectShift.name + description + "%0D%0AHeure de début : " + projectShift.start_time + "%0D%0AHeure de fin : " + projectShift.end_time + "%0D%0AJours de la semaine : " + this.daysOfWeekStr + "%0D%0ADates : " + dates + "%0D%0A%0D%0AMerci, %0D%0A" + me + title;
            },

            date2str(date){
                return date2str(date);
            }
        },
        apollo: {
            assignmentsAll: {
                query: ASSIGNMENTSALL,
                watchLoading(isLoading) {
                    this.loadingA = isLoading;
                },
                fetchPolicy: 'network-only',	//cache-first, cache-and-network, cache-only, network-only, no-cache -> https://v4.apollo.vuejs.org/guide-composable/query.html#fetch-policy
                skip(){
                    return this.skipQueriesStart
                },
                //debounce: 200,
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
                },
                variables(){
                    let variables={
                        date: this.summary.date
                    }
                    return {
                        ...variables
                    }
                },
                update(assignments) {
                    return assignments
                },
            },
            draftAssignmentsAll: {
                query: DRAFTASSIGNMENTSALL,
                watchLoading(isLoading) {
                    this.loadingD = isLoading;
                },
                fetchPolicy: 'network-only',	//cache-first, cache-and-network, cache-only, network-only, no-cache -> https://v4.apollo.vuejs.org/guide-composable/query.html#fetch-policy
                skip(){
                    return this.skipQueriesStart
                },
                //debounce: 200,
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
                },
                variables(){
                    let variables={
                        date: this.summary.date
                    }
                    return {
                        ...variables
                    }
                },
                update(draftAssignments) {
                    return draftAssignments
                },
            },
            
            myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
            },
        }
    }
</script>

<style lang="scss" scoped>
    .-report-label{
        font-size: 0.8rem;

    }

    .row {
        align-items: baseline;
    }

    .-summary-frame, .-summary-no-frame {
        background-color: $color-0-lighter;
        border-radius: 3px;
        padding: 16px;
        // color: $color-0-dark;
        // font-size: 9px;
        // font-weight: 700;

        & h2,
        & h3 {
            color: $color-1-darkest;
        }

        .-head, .-body {
            font-size: 0.75rem;
            &>div {
                padding: 8px 4px;
            }
        }
        .-body {
            font-size: 0.9rem;
            border-bottom: 1px solid $color-0-light;
        }
        .-head {
            color: $color-0-dark;
            text-transform: uppercase;
        }
        & .-filters {
            align-items: end;
        }
    }

    .-summary-no-frame {
        background-color: $white;
    }
    // .-title {

    // }
    .c-project-card__wrap {
        min-height: 75vh;
    }

    .total-row {
        position: sticky;
        bottom: 0;
        background-color: white;
    }
</style>


<style lang="scss">
    @import '@/scss/settings/_fonts.scss';

    .-summary-frame,
    .-summary-no-frame {
        font-size: 0.95rem !important;
        .q-field__label {
            font-size: 0.98rem !important;
        }

        & .q-field__native {
            font-size: 10px !important;

            &>span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-family: $font-ellipsis;
            }
        }
    }
</style>